import { environment } from '../../environments/environment';

export const URL_SERVICIOS = environment.urlServices;
export const URL_SERVICIOS_CUEJ = environment.urlServicesCuej;